import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { findIndex, includes } from 'lodash';
import classnames from 'classnames';

export class Tabs extends React.Component {
  render () {
    const indexOfActiveTab = findIndex(this.props.tabs, (tab) => {
      // used includes instead of an exact string match using ===
      // because of sub params e.g. /account/taxes/submitted
      return includes(window.location.pathname, `/${tab.link}`);
    });

    const activeTab = -1 !== indexOfActiveTab ? indexOfActiveTab : 0;

    return (
      <div className="NavTab margin-lg-bottom">
        <ul className="flex">
          {
            this.props.tabs.map((tab, index) => {
              const { link, label } = tab;
              const isActive = activeTab === index;
              const className = classnames({ active: isActive });

              if (1 === this.props.tabs.length) {
                return (
                  <li className="text-large">{label}</li>
                );
              }

              return (
                <li className={className} key={link}>
                  <Link
                    to={{ pathname: `/${link}` }}
                  >
                    {label}
                  </Link>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  }
}

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired
};
